import { useSelector } from "react-redux";
import { useOrganizationFeatures } from "@/shared/hooks/useOrganizationFeatures";
import type { RootState } from "@/store";
import { useChatNotifications } from "../hooks/useChatNotifications";
import { useRoomChannelsReauth } from "../hooks/useRoomChannelsReauth";

/**
 * Subscribes to chat unread events at the app root, so the navbar badge,
 * browser notification, and tab attention fire on every page — not only
 * while the chat panel is mounted. Gated on `serviceChat` so users without
 * the chat feature don't trigger Pusher private-channel auth failures.
 */
export function ChatGlobalListener() {
  const user = useSelector((state: RootState) => state.session.user);
  const { serviceChat } = useOrganizationFeatures();
  const representativeId = serviceChat ? user?.representative?.id ?? null : null;
  useChatNotifications(representativeId);
  useRoomChannelsReauth(user?.representative?.hide_chat ?? false);
  return null;
}
